const hospitalClinics=
{
BTH:{
    rdc:['colorectal', 'lung', 'mesothelioma', 'oesophagus', 'pancreas', 'stomach', 'liverGb', 'breast', 'ovarian', 'endometrial', 'cervical', 'vulval', 'vaginal', 'prostate', 'bladder', 'renal', 'testicular', 'penile', 'melanoma', 'squamous', 'basal', 'laryngeal', 'oral', 'thyroid',  'leukaemia', 'myeloma', 'nonHodgkins', 'hodgkins',  'neuroblastoma', 'retinoblastoma', 'wilms', 'nonSpecific', 'childConcern'],
    
    nonRdc:["colorectal surgery","respiratory","upper GI surgery","hepatobiliary surgery","gynaecology","urology","dermatology","ENT","faciomaxillary surgery","haematology","orthopaedic surgery","paediatrics","opthalmology","gastroenterology"]
    },


ELTH:{
    rdc:['colorectal', 'lung', 'mesothelioma', 'oesophagus', 'pancreas', 'stomach', 'liverGb', 'breast', 'ovarian', 'endometrial', 'cervical', 'vulval', 'vaginal', 'prostate', 'bladder', 'renal', 'testicular', 'penile', 'melanoma', 'squamous', 'basal', 'laryngeal', 'oral', 'thyroid',  'leukaemia', 'myeloma', 'nonHodgkins', 'hodgkins', 'neuroblastoma', 'retinoblastoma', 'wilms', 'nonSpecific', 'childConcern'],

    nonRdc:["colorectal surgery","respiratory","upper GI surgery","hepatobiliary surgery","gynaecology","urology","dermatology","ENT","faciomaxillary surgery","haematology","orthopaedic surgery","paediatrics","opthalmology","gastroenterology"]
    },


LTH:{
    rdc:['colorectal', 'lung', 'mesothelioma', 'oesophagus', 'pancreas', 'stomach', 'liverGb', 'breast', 'ovarian', 'endometrial', 'cervical', 'vulval', 'vaginal', 'prostate', 'bladder', 'renal', 'testicular', 'penile', 'melanoma', 'squamous', 'basal', 'laryngeal', 'oral', 'thyroid', 'cns', 'leukaemia', 'myeloma', 'nonHodgkins', 'hodgkins', 'boneSarcoma', 'softTissueSarcoma', 'neuroblastoma', 'retinoblastoma', 'wilms', 'nonSpecific', 'childConcern'],

    nonRdc:["colorectal surgery","respiratory","upper GI surgery","hepatobiliary surgery","gynaecology","urology","dermatology","ENT","faciomaxillary surgery","neurosurgery","haematology","orthopaedic surgery","paediatrics","opthalmology","gastroenterology"]
    },

  UHMB:{
        rdc:['colorectal', 'lung', 'mesothelioma', 'oesophagus', 'pancreas', 'stomach', 'liverGb', 'breast', 'ovarian', 'endometrial', 'cervical', 'vulval', 'vaginal', 'prostate', 'bladder', 'renal', 'testicular', 'penile', 'melanoma', 'squamous', 'basal', 'laryngeal', 'oral', 'thyroid',  'leukaemia', 'myeloma', 'nonHodgkins', 'hodgkins',  'neuroblastoma', 'retinoblastoma', 'wilms', 'nonSpecific', 'childConcern'],
        
        nonRdc:["colorectal surgery","respiratory","upper GI surgery","hepatobiliary surgery","gynaecology","urology","dermatology","ENT","faciomaxillary surgery","haematology","orthopaedic surgery","paediatrics","opthalmology","gastroenterology"]
        },

ROHBirmingham:{
        rdc:['boneSarcoma'],
        nonRdc:["orthopaedic"]
}

}

export default hospitalClinics